import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useCurrentUserContext } from 'utils/User';

import ROUTE_NAMES from 'setup/Routing/routeNames';

import useSentinelTeam from 'hooks/useSentinelTeam';

export default function SentinelAdminOrManagerRoute({ children }) {
  const { isAdmin, isOemManager } = useCurrentUserContext();
  const { hasSentinelTeam } = useSentinelTeam();
  const location = useLocation();

  const shouldRedirect = useMemo(
    () => !(isAdmin || isOemManager) || !hasSentinelTeam,
    [isAdmin, isOemManager, hasSentinelTeam],
  );

  if (shouldRedirect) {
    return (
      <Navigate
        to={ROUTE_NAMES.access_denied}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
}

SentinelAdminOrManagerRoute.propTypes = {
  children: PropTypes.node,
};

SentinelAdminOrManagerRoute.defaultProps = {
  children: null,
};
